import { tassign } from 'tassign';
import { Actions, ActionTypes } from './unassigned-pickups-store.actions';
import { initialState, State } from './unassigned-pickups-store.state';

export function unassignedPickupsReducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.setSearchCriteria: {
      return tassign(state, {
        criteria: action.payload.criteria,
      });
    }

    case ActionTypes.setSelectedUnassignedPickups: {
      return tassign(state, {
        selectedPickups: action.payload.selectedPickups,
      });
    }

    case ActionTypes.setFocusedUnassignedPickup: {
      return tassign(state, {
        focusedPickup: action.payload.focusedPickup,
      });
    }

    case ActionTypes.setBoundingSearchArea: {
      return tassign(state, {
        boundingSearchArea: action.payload.boundingSearchArea,
      });
    }

    default: {
      return state;
    }
  }
}
